const c = (e, r = "_") => {
  if (!e) return "";
  if (e.search(r) === -1)
    return e.charAt(0).toLocaleUpperCase() + e.slice(1).toLocaleLowerCase();
  const o = e.split(r);
  let a = "";
  for (let t = 0; t < o.length; t++)
    a = a + o[t].charAt(0).toUpperCase() + o[t].slice(1).toLocaleLowerCase() + " ";
  return a.trim();
};
export {
  c as t
};
